import { IAsset } from '../../../../../Interfaces/Asset/IAsset';
import { IAssetTypeId } from '../../../../../Interfaces/Asset/IAssetType';
import { BankAccountAssetView } from './TestamentAssetView/BankAccountAssetView';
import { CashAssetView } from './TestamentAssetView/CashAssetView';
import { DepotAssetView } from './TestamentAssetView/DepotAssetView';
import { LoanAssetView } from './TestamentAssetView/LoanAssetView';
import { MortgageAssetView } from './TestamentAssetView/MortgageAssetView';
import { OtherAssetView } from './TestamentAssetView/OtherAssetView';

export const TestamentAssetsView: React.FC<{
  asset: IAsset;
  setAsset: (asset: IAsset) => void;
  realEstates: IAsset[];
}> = ({ asset, setAsset, realEstates }) => {
  switch (asset.idAssetType) {
    case IAssetTypeId.BankAccount:
      return <BankAccountAssetView asset={asset} setAsset={setAsset} />;
    case IAssetTypeId.Cash:
      return <CashAssetView asset={asset} setAsset={setAsset} />;
    case IAssetTypeId.Depot:
      return <DepotAssetView asset={asset} setAsset={setAsset} />;
    case IAssetTypeId.Mortgage:
      return (
        <MortgageAssetView
          asset={asset}
          setAsset={setAsset}
          realEstateAssets={realEstates}
        />
      );
    case IAssetTypeId.Loan:
      return <LoanAssetView asset={asset} setAsset={setAsset} />;
    case IAssetTypeId.Other:
      return <OtherAssetView asset={asset} setAsset={setAsset} />;
    default:
      return <div>Unknown Asset Type</div>;
  }
};
